export const getSelectedPropertyIds = state => state.selectList.selectedPropertyIds;
